export function formatDate(timestamp) {
  if (!timestamp) return '-';
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatShortDate(timestamp) {
  if (!timestamp) return '-';
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function truncateText(text, maxLength = 100) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export const POST_TYPES = {
  NEWS: { label: 'Новость', value: 'NEWS' },
  PROJECT: { label: 'Проект', value: 'PROJECT' },
  PARTNER: { label: 'Партнёр', value: 'PARTNER' },
};

export function getPostTypeLabel(type) {
  const postType = POST_TYPES[type];
  return postType ? postType.label : type;
}
